/* eslint-disable react/button-has-type */
import { CircularProgress } from "@mui/material";
import React from "react";

export default function SpecificButton({ buttonFunc, prefix,postfixIcon, className, buttonText,btnSecondary, loading = false, disabled, type = "button", id = "button", ...props }) {
  return (
    <button
      {...props}
      id={id}
      type={type}
      disabled={disabled}
      onClick={buttonFunc}
      className={`${className} ${btnSecondary ? 'flex gap-[5px] items-center shadow-[0_1px_1px_rgba(0,0,0,0.251)] justify-center [&_svg]:size-4 [&_svg]:shrink-0 rounded-full min-w-[120px] text-[14px] px-6 bg-black text-white disabled:shadow-none  disabled:text-black disabled:bg-secondary disabled:pointer-events-none font-medium py-[6px] ' : 'btn-custom whitespace-nowrap px-4 hover:bg-btn/90 text-sm font-medium h-10 py-2 w-full text-btnText rounded-full bg-btn ring-offset-bg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0'}`}
    >
      {prefix && <img src={prefix} alt="icon" />}
      {buttonText}
      {postfixIcon && postfixIcon}
      {loading && disabled && <CircularProgress size={15} />}
    </button>
  );
}
